import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { ContinueButton } from './Submit/ContinueButton';
import { ExitButton } from './Submit/ExitButton';
import { BackButton } from './Submit/BackButton';
import { ExitModal } from './Submit/ExitModal';
import { redirectToExit } from '../store/dataCapture/actions';
import { selectors as configSelectors } from '../infrastructure/config';
import { selectors as caseSelectors } from '../infrastructure/cases';
import { NAVIGATION_BACK, ROUTE_TECHNICAL_ERROR_PAGE } from '../utils/constants';
import { redirectToBackScreen } from '../store/dataCapture/actions';

const Submit = ({ submitButtonText, disabled, hideExit = false, exitButtonText }) => {
  const dispatch = useDispatch();
  const { pathName, saveEnabled, username, isGDPRModel } = useSelector((state) => ({
    pathName: state.router.location.pathname,
    saveEnabled: !!configSelectors.getCaseId(state),
    username: caseSelectors.getUsername(state),
    isGDPRModel: state.dataCapture.get('isOpen')
  }));
  const [isExitModalOpen, toggleExitModal] = useState(false);
  const handleToggle = () => toggleExitModal(!isExitModalOpen);
  const handleExit = () => {
    return dispatch(redirectToExit(NAVIGATION_BACK));
  };
  const isBackNavigationNeeded = pathName !== ROUTE_TECHNICAL_ERROR_PAGE;
  const handleBackClick = () => {
    dispatch(redirectToBackScreen(pathName, isGDPRModel));
  };
  return (
    <div>
      <NavigationButtonGroup
        tertiaryButtons={
          !hideExit && (
            <ExitButton
              onClick={toggleExitModal}
              saveEnabled={saveEnabled}
              exitButtonText={exitButtonText}
            />
          )
        }
        primaryButton={<ContinueButton submitButtonText={submitButtonText} disabled={disabled} />}
        secondaryButtons={isBackNavigationNeeded && <BackButton onClick={handleBackClick} />}
      />

      {!hideExit &&
        ExitModal({
          toggleModal: handleToggle,
          handleExit,
          saveEnabled,
          username,
          isExitModalOpen
        })}
    </div>
  );
};

export default Submit;
